import { parseResponse, requestAuthAdmin } from './auth';
import { getSelectedEnvironment } from '../utils/apiEnvironment';
import { parseCandidateFile } from '../page/ContentCandidates/candidateFile';

export const CONTENT_CANDIDATES_PATH = '/api-admin/v0/content-candidates';
export const CONTENT_CANDIDATES_TEST_ENDPOINT = `${process.env.REACT_APP_AUTH_ADMIN_TEST_URL || 'https://test-auth-admin.fancian.net'}${CONTENT_CANDIDATES_PATH}?environment=test`;
export const CANDIDATE_DECISIONS = ['PENDING', 'ADOPTED', 'REJECTED'];

function validateReviews(data) {
  if (!data || typeof data.revision !== 'string' || !data.reviews || typeof data.reviews !== 'object' || Array.isArray(data.reviews)) throw new Error('Invalid candidate reviews');
  if (!Object.values(data.reviews).every(review => review && CANDIDATE_DECISIONS.includes(review.decision) && typeof review.hidden === 'boolean')) throw new Error('Invalid candidate decision');
  return data;
}

async function request(method, input, token, environment, signal) {
  if (!token) throw Object.assign(new Error('Not authenticated'), { status: 401 });
  if (environment !== 'test') throw Object.assign(new Error('Candidate inbox is TEST only'), { status: 403 });
  if (getSelectedEnvironment() !== environment) throw new Error('Candidate environment changed');
  const writing = method === 'PATCH';
  let response;
  try {
    response = await requestAuthAdmin(`${CONTENT_CANDIDATES_PATH}?environment=${environment}${writing ? '' : '&view=queue'}`, {
      method, ...(signal ? { signal } : {}), ...(writing ? { body: JSON.stringify(input) } : {}),
    }, token);
  } catch (error) { throw Object.assign(error, writing ? { uncertain: true } : {}); }
  let body;
  try { body = await parseResponse(response, CONTENT_CANDIDATES_PATH); }
  catch (error) { throw Object.assign(error, writing && (!error.status || error.status >= 500 || response.ok) ? { uncertain: true } : {}); }
  try {
    const data = validateReviews(body?.data);
    if (!writing) {
      if (!Array.isArray(data.batches)) throw new Error('Invalid candidate batches');
      const ids = new Set();
      data.batches.forEach(batch => {
        parseCandidateFile(JSON.stringify(batch));
        batch.candidates.forEach(candidate => {
          if (ids.has(candidate.id)) throw new Error('Duplicate candidate ID');
          ids.add(candidate.id);
        });
      });
    }
    return data;
  } catch (error) { throw Object.assign(error, writing ? { uncertain: true } : {}); }
}

export function getContentCandidates(token, environment, signal) {
  return request('GET', null, token, environment, signal);
}

export function updateCandidateReview(input, token, environment) {
  if (!input?.candidate_id || !CANDIDATE_DECISIONS.includes(input.decision) || typeof input.hidden !== 'boolean' || typeof input.expected_revision !== 'string') return Promise.reject(new Error('Invalid candidate review request'));
  return request('PATCH', input, token, environment);
}
